// extracted by mini-css-extract-plugin
export var name = "speaker-module--name--5fd6f";
export var row = "speaker-module--row--05e46";
export var speaker = "speaker-module--speaker--4b778";